module.exports = __webpack_public_path__ + "img/Main-Screen-Background.0defb54c.webp";